import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultConfig,
  RainbowKitProvider,
  lightTheme,
  darkTheme
} from '@rainbow-me/rainbowkit';
import {
  metaMaskWallet,
  rainbowWallet,
  coinbaseWallet,
  walletConnectWallet,
  trustWallet,
  safepalWallet,
  okxWallet,
  binanceWallet
} from '@rainbow-me/rainbowkit/wallets';
import { WagmiProvider } from 'wagmi';
import { mainnet, bsc, polygon, arbitrum } from 'wagmi/chains';
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import useConfig from 'hooks/useConfig';

const projectId = '04309ed1007e11d08770932585973703';

const config = getDefaultConfig({
  appName: 'Bizora',
  projectId,
  chains: [mainnet, bsc, polygon, arbitrum],
  wallets: [
    {
      groupName: 'Recommended',
      wallets: [
        metaMaskWallet,
        trustWallet,
        safepalWallet,
        binanceWallet,
        walletConnectWallet,
      ],
    },
    {
      groupName: 'Others',
      wallets: [
        rainbowWallet,
        coinbaseWallet,
        okxWallet,
      ],
    },
  ],
  ssr: false,
});

const queryClient = new QueryClient();

export const Web3Provider = ({ children }) => {
  const { state } = useConfig();
  const { mode } = state;

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider theme={mode === 'dark' ? darkTheme() : lightTheme()} modalSize="compact">
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};
